export default __webpack_public_path__ + "static/EasyTipster_mockups-3dce5be3d2f496b2e87fe2b460250e31.png";